import {Modal, Spinner} from '@peachy/client-kit'
import {Component, createSignal} from 'solid-js'
import {CancelButtons} from './CancelButtons'
import {CancelMembers} from './CancelMembers'
import {CancelModalContactDetails} from './CancelModalContactDetails'
import {CancelReason} from './selector/CancelReason'
import {useSubscriptionService} from '../../../../controllers/DashboardServiceController'
import {useAccountSubscription} from '../SubscriptionProvider'
import {CancelModalProps} from './CancelModalProps'
import styles from './Modal.module.css'


export const CancelSubscriptionModal: Component<CancelModalProps> = (props) => {

    const [enabled, setEnabled] = createSignal(false)
    const [isCancelling, setIsCancelling] = createSignal(false)
    const [reason, setReason] = createSignal('')

    const subscriptionService = useSubscriptionService()
    const accountSubscription = useAccountSubscription()
    const account = accountSubscription.account
    const subscription = accountSubscription.subscription

    const onDismiss = () => {
        setEnabled(false)
        props.onDismiss()
    }


    const onSelectReason = (reason: string) => {
        setEnabled(true)
        setReason(reason)
    }

    const onCancelSubscription = async () => {
        setIsCancelling(true)
        try {
            await subscriptionService.cancelSubscription({
                accountId: account.id,
                subscriptionId: subscription.id,
                cancellationReason: reason(),
            })

        } catch (e) {
            console.error(e)
        } finally {
            setIsCancelling(false)
            onDismiss()
        }
    }

    return (<>
        <Modal isOpen={props.isOpen} class={styles.modal}>
            <section>
                <p>Are you sure you want to cancel this subscription?</p>
                <CancelReason onSelect={onSelectReason} selectedReason={reason}/>
                <CancelModalContactDetails/>
                <CancelMembers/>
                <CancelButtons enabled={enabled()} onDismiss={onDismiss} onCancel={onCancelSubscription}/>
            </section>
        </Modal>
        <Spinner isShown={isCancelling()}/>
    </>)
}
